import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tamr-icon-ic_assignment",
  "use": "tamr-icon-ic_assignment-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol viewBox=\"0 0 21 21\" xmlns=\"http://www.w3.org/2000/svg\" id=\"tamr-icon-ic_assignment\"><defs><style>#tamr-icon-ic_assignment .cls-1{fill:none;}</style></defs><path class=\"cls-1\" d=\"M0,0H24V24H0Z\" /><path d=\"M19,3H14.82A3,3,0,0,0,9.18,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3ZM12,3a1,1,0,1,1-1,1A1,1,0,0,1,12,3Zm2,14H7V15h7Zm3-4H7V11H17Zm0-4H7V7H17Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol